import http from '@/api/http'

export default {
  forgot ( email ) {
    return http({ url: '/password/forgotten', method: 'post', data: { email: email } })
  },
  reset ( data ) {
    return http({ url: '/password/reset', method: 'post', data: data })
  }
}
